import { getSessionBrand } from '../../../../infra/session/selectors';
import { isBarberSessionView } from '../../../../infra/session';
export var canUseSmsChannel = function (_a) {
    var session = _a.session;
    var brand = getSessionBrand(session);
    var brandOriginator = brand === null || brand === void 0 ? void 0 : brand.smsOriginator;
    var isBrandOriginatorVerified = brand === null || brand === void 0 ? void 0 : brand.smsOriginatorVerified;
    if (isBarberSessionView(session.view)) {
        var isStudioOwner = session.view.viewer.type === 'studio';
        return !!brandOriginator && !!isBrandOriginatorVerified && !isStudioOwner;
    }
    return !!brandOriginator && !!isBrandOriginatorVerified;
};
